/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RootLayout from './layouts/RootLayout';
const ProtectedRoute = ({ children, allowedRoles, role }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const checkUserToken = () => {
    const userToken = localStorage.getItem('userAuthToken');

    if (!userToken || userToken === 'undefined') {
      setIsLoggedIn(false);
      localStorage.removeItem('locationIp');
      navigate('/seva-login');
    } else {
      setIsLoggedIn(true);
      setUserRole(role);
    }
  };

  useEffect(() => {
    checkUserToken();
  }, []);

  // Redirect if the user doesn't have permission
  useEffect(() => {
    if (
      isLoggedIn &&
      (userRole === 'Admin' ||
        userRole === 'Super-Admin' ||
        userRole === 'Grievance-Admin-Access' ||
        userRole === 'Director')
    ) {
      navigate('/dashboard');
    } else if (isLoggedIn && userRole === 'Web-Portal-Data-Entry') {
      navigate('/news');
    } else if (
      isLoggedIn &&
      (userRole === 'Grievance-Data-Entry-Operator' ||
        userRole === 'Grievance-Manager-Access')
    ) {
      navigate('/gms');
    }
  }, [isLoggedIn, userRole]);

  return isLoggedIn ? <RootLayout>{children}</RootLayout> : null;
};

export default ProtectedRoute;
